<template>
  <div class="national-top-center">
    <h2 class="title">累计交易额</h2>
    <countTo
      class="all-total"
      :autoplay="isTrue"
      :startVal="startValue"
      :endVal="amount"
      :duration="time"
      :decimals="num"
    ></countTo>
    <ul class="list">
      <li>
        <h3>{{lastPrice}}</h3>
        <h4>最新成交价(元)</h4>
      </li>
      <li>
        <h3>{{ last30DayAmount }}</h3>
        <h4>近30日交易额(元)</h4>
      </li>
      <li>
        <h3>{{thisYearAmount}}</h3>
        <h4>本年销售额(元)</h4>
      </li>
    </ul>
    <ul class="list">
      <li>
        <h3>{{areaCount}}</h3>
        <h4>养殖面积(亩)</h4>
      </li>
      <li>
        <h3>{{fishBaseCount}}</h3>
        <h4>养殖基地数(个)</h4>
      </li>
      <li>
        <h3>{{userCount}}</h3>
        <h4>用户数量(个)</h4>
      </li>
    </ul>
  </div>
</template>

<script>
new function() {
  var _self = this;
  _self.width = 1920; //设置默认最大宽度
  _self.fontSize = 100; //默认字体大小
  _self.widthProportion = function() {
    var p =
      ((document.body && document.body.clientWidth) ||
        document.getElementsByTagName("html")[0].offsetWidth) / _self.width;
    return p > 1 ? 1 : p < 0.4 ? 0.5 : p;
  }; //判断当前屏幕尺寸，设置的最大屏幕宽度之间的比例
  _self.changePage = function() {
    document
      .getElementsByTagName("html")[0]
      .setAttribute(
        "style",
        "font-size:" +
          _self.widthProportion() * _self.fontSize +
          "px !important"
      );
  }; //修改根元素html的font-size的植
  _self.changePage();
  window.addEventListener(
    "resize",
    function() {
      _self.changePage();
    },
    false
  ); //侦听屏幕宽度变化
}();
import countTo from "vue-count-to";
export default {
  name: "topCenter",
  data() {
    return {
      isTrue: true,
      startValue: 0,
      num: 2, //两位小数点
      time: 1500, //1.5秒完成滚动
      amount: 0,
      last30DayAmount: 0,
      thisYearAmount: 0,
      lastPrice: 0,
      fishBaseCount: 0,
      areaCount: 0,
      fishPondCount: 0,
      userCount: 0
    };
  },
  components: {
    countTo
  },
  //方法集合
  methods: {
    // 获取首页大数据
    async getRealTimeBaseAndSale() {
      let res = await this.$api.getRealTimeBaseAndSale();
      let data = res.data;
      this.last30DayAmount = data.last30DayAmount;
      this.thisYearAmount = data.thisYearAmount;
      this.lastPrice = data.lastPrice;
      this.fishBaseCount = data.fishBaseCount;
      this.areaCount = data.areaCount;
      this.fishPondCount = data.fishPondCount;
      this.userCount = data.userCount;
    },
    async getRealTimeTotal() {
      let res = await this.$api.getRealTimeTotal();
      this.amount = res.data.amount;
    }
  },
  async mounted() {
    this.getRealTimeBaseAndSale();
    this.getRealTimeTotal();
    window.countTimer = setInterval(() => {
      this.startValue = Math.random();
    }, 6000);
  },
  beforeDestroy() {
    clearInterval(window.countTimer);
  }
};
</script>
<style lang="stylus" scoped>
.national-top-center {
  .title {
    font-size: 2.22vh;
    padding-top: 1.31vh;
    text-align: center;
    color: #FFF;
    font-weight: 400;
  }
  .all-total {
    font-size: 6.66vh;
    color: #ffd200;
    font-family: "微软雅黑";
    text-align: center;
    letter-spacing: 2px;
    margin-bottom: 10px;
    font-family: Microsoft YaHei UI;
    font-weight: bold;
  }
  .list {
    display: flex;
    li {
      width: 33%;
      border-right: 1px solid #FFF;
      margin-bottom: 10px;
      &:last-child {
        border-right: 0px solid #FFF;
      }
      h3 {
        color: #ffd200;
        font-size: 3vh;
        font-family: Microsoft YaHei UI;
        font-weight: bold;
      }
      h4 {
        color: #ffffff;
        font-size: 1.66vh;
      }
    }
  }
}
</style>
